export const PreparationWidgetSkeleton = [
    // Main container with background
    {
        span: 6,
        height: "auto",
        classes: "marginTop-56 paddingY-16 paddingX-16",
    },
    // Header section
    {
        span: 6,
        height: "24px",
        classes: "marginTop-0",
    },
    // Header underline image
    {
        span: 6,
        height: "4px",
        classes: "marginTop-4",
    },
    // Items container - TestDescription (first item)
    {
        span: 15,
        height: "80px",
        classes: "marginTop-4",
    },
    // Items container - DetailsCard items (subsequent items)
    {
        classes: "marginTop-12",
        columns: [
            { span: 5, height: "120px" },
            { span: 5, height: "120px", classes: "marginLeft-12" },
            { span: 5, height: "120px", classes: "marginLeft-12" },
        ],
    },
]
